import { useState } from "react";
import type { Person } from "@/types";
import { formatYearsAndMonths } from "./activeYearsBreakdown";

export default function useActiveYearsBreakdown(person: Pick<Person, "activeDaysOfMembership">) {
  const [breakdownOpen, setBreakdownOpen] = useState(false);

  const activeYearsValue =
    person.activeDaysOfMembership == null ? null : formatYearsAndMonths(person.activeDaysOfMembership);

  return {
    breakdownOpen,
    openBreakdown: () => setBreakdownOpen(true),
    closeBreakdown: () => setBreakdownOpen(false),
    activeYearsValue
  };
}
